import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import Lottie from "lottie-react";
import SuccessLottie from '@/static/success.json';
var AuthSuccess = function () {
    return (_jsxs(Box, { sx: { height: '100vh', width: '100%', pt: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }, children: [_jsx(Box, { sx: { width: 200 }, children: _jsx(Lottie, { loop: false, animationData: SuccessLottie }) }), _jsx(Typography, { sx: { my: 1 }, variant: 'h6', children: "You are now authorized. You may close this window" })] }));
};
export default AuthSuccess;
